(function () {
  function initBundlePdp(root) {
    if (!root || root.__bundleInit) return;
    root.__bundleInit = true;
    console.log('[bundle-pdp] init', root.id);

    const form = root.querySelector('form[id^="bundle-product-form-"]');
    const variantsScript = root.querySelector('[data-bundle-product-variants]');
    let variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (_) {
      variants = [];
    }

    const tilesContainer = root.querySelector('.bundle-pdp__tiles');
    const tiles = root.querySelectorAll('.bundle-pdp__tile');
    const flavorContainer = root.querySelector('.bundle-pdp__bags');
    const bagRows = root.querySelectorAll('.bundle-pdp__bag-row');
    const submitBtn = root.querySelector('.bundle-pdp__submit');
    const stickyCta = root.querySelector('[data-bundle-sticky-cta]');
    const totalEls = root.querySelectorAll('[data-total-price]');
    const totalMetaEls = root.querySelectorAll('[data-total-meta]');
    const subscribeRadio = root.querySelector('input[name="bundle-purchase-mode"][value="subscribe"]');
    const onetimeRadio = root.querySelector('input[name="bundle-purchase-mode"][value="onetime"]');
    const subscribeOptionLabel = root.querySelector('.bundle-pdp__option--subscribe');
    const onetimeOptionLabel = root.querySelector('.bundle-pdp__option--onetime');
    const subscribeDiscountPct = subscribeOptionLabel ? parseFloat(subscribeOptionLabel.dataset.subscribeDiscountPct) || 0 : 0;
    const subscribeFactor = (100 - subscribeDiscountPct) / 100;
    const frequencySelect = root.querySelector('[data-selling-plan-select]');
    const sellingPlanInput = root.querySelector('input[name="selling_plan"]');
    const subscribePriceEl = root.querySelector('[data-subscribe-price]');
    const subscribeCompareEl = root.querySelector('[data-subscribe-compare]');
    const onetimePriceEl = root.querySelector('[data-onetime-price]');
    const submitLabelEls = root.querySelectorAll('.bundle-pdp__submit-label');
    const buildLabel = 'Build Your Bundle';
    const onetimeLabel = 'Buy now';
    const subscribeLabel = 'Subscribe Now';

    const flavorOptionIndex = flavorContainer ? parseInt(flavorContainer.dataset.flavorOptionIndex, 10) : -1;
    const hasFlavorUI = !!flavorContainer && bagRows.length > 0;

    function normalize(s) {
      return (s == null ? '' : String(s)).trim().toLowerCase();
    }

    function findVariant(flavorValue) {
      if (!variants.length) return null;
      const targetFlavor = normalize(flavorValue);
      for (const v of variants) {
        const opts = v.options || [];
        const flavorMatch = flavorOptionIndex < 0 ? true : normalize(opts[flavorOptionIndex]) === targetFlavor;
        if (flavorMatch) return v;
      }
      return null;
    }

    // Fails open if variant data is missing — Shopify still blocks oversell server-side.
    function flavorHasStock(flavorValue) {
      if (!variants.length) return true;
      const target = normalize(flavorValue);
      return variants.some((v) => {
        const opts = v.options || [];
        const flavorMatch = flavorOptionIndex < 0 ? true : normalize(opts[flavorOptionIndex]) === target;
        return flavorMatch && v.available;
      });
    }

    const productId = root.dataset.productId ? parseInt(root.dataset.productId, 10) : null;
    const cartLimit = root.dataset.cartLimit ? parseInt(root.dataset.cartLimit, 10) : 0;
    let cartLimitReached = false;
    let cartBundleKeys = new Set();

    // Reads the live cart once and refreshes both the per-product cart limit
    // and the set of bundle signatures (_bundle_key) already in the cart.
    async function checkCartLimit() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        if (productId && cartLimit) {
          const qty = cart.items
            .filter((item) => item.product_id === productId)
            .reduce((sum, item) => sum + item.quantity, 0);
          cartLimitReached = qty >= cartLimit;
        }
        cartBundleKeys = new Set();
        cart.items.forEach((item) => {
          const key = item.properties && item.properties._bundle_key;
          if (key) cartBundleKeys.add(key);
        });
        updateSubmitState();
      } catch (_) {}
    }

    function enforceDrawerCartLimit(drawer, pId, limit) {
      if (!limit || limit <= 0 || !pId) return;
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          cart.items.forEach((item, idx) => {
            if (item.product_id !== pId) return;
            if (item.quantity < limit) return;
            const n = idx + 1;
            const row = drawer.querySelector(`#CartDrawer-Item-${n}`) || drawer.querySelector(`#CartItem-${n}`);
            if (!row) return;
            const qtyControl = row.querySelector('quantity-input') || row.querySelector('.quantity');
            if (qtyControl) qtyControl.style.display = 'none';
          });
        })
        .catch(() => {});
    }

    function watchDrawerForLimit(drawer, pId, limit) {
      if (!limit || limit <= 0 || !pId || !drawer) return;
      let debounceTimer;
      new MutationObserver(() => {
        enforceDrawerCartLimit(drawer, pId, limit);
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => checkCartLimit(), 300);
      }).observe(drawer, { childList: true, subtree: true });
    }

    let bagCount = 0;
    const initialTile = root.querySelector('.bundle-pdp__tile.is-selected');
    if (initialTile) bagCount = parseInt(initialTile.dataset.bagCount, 10) || 0;

    // Disable flavor options whose flavor is entirely out of stock.
    root.querySelectorAll('.bundle-pdp__flavor-select').forEach((sel) => {
      Array.from(sel.options).forEach((opt) => {
        if (opt.value && !flavorHasStock(opt.value)) {
          opt.disabled = true;
          opt.textContent = opt.textContent + ' (Sold out)';
        }
      });
    });

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedTile() {
      return root.querySelector('.bundle-pdp__tile.is-selected');
    }

    function getSelectedFlavors() {
      const flavors = [];
      const visibleRows = Array.from(bagRows).filter((r) => !r.classList.contains('is-hidden'));
      visibleRows.forEach((row) => {
        const sel = row.querySelector('.bundle-pdp__flavor-select');
        if (sel && sel.value) flavors.push(sel.value);
      });
      return flavors;
    }

    function visibleBagRowCount() {
      return Array.from(bagRows).filter((r) => !r.classList.contains('is-hidden')).length;
    }

    function isSubscribe() {
      return subscribeRadio && subscribeRadio.checked;
    }

    function getSelectedVariant() {
      const variantInput = form && form.querySelector('[name="id"]');
      const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (variantId) {
        const match = variants.find((v) => v.id === variantId);
        if (match) return match;
      }
      // Fall back to the first available variant, then the first variant.
      return variants.find((v) => v.available) || variants[0] || null;
    }

    function getBaseTotal() {
      const t = getSelectedTile();
      if (t) return parseInt(t.dataset.bagPrice, 10) || 0;
      // Simple mode (no quantity tiles): use the selected/first variant price
      // so the buy button still shows a price — including $0.00 for free products.
      if (!tiles.length) {
        const v = getSelectedVariant();
        return v ? v.price : 0;
      }
      return 0;
    }

    function updateBagVisibility() {
      bagRows.forEach((row) => {
        const idx = parseInt(row.dataset.bagIndex, 10);
        row.classList.toggle('is-hidden', bagCount === 0 || idx > bagCount);
      });
      const flavorSection = root.querySelector('.bundle-pdp__flavors-section');
      if (flavorSection) flavorSection.classList.toggle('is-empty', bagCount === 0);
    }

    function updateTotals() {
      const tile = getSelectedTile();
      const base = getBaseTotal();
      const isSub = isSubscribe();
      const final = isSub ? Math.round(base * subscribeFactor) : base;
      // Show a price when a tile is selected, or always in simple mode (no tiles).
      const hasPrice = tile || !tiles.length;
      const totalText = hasPrice ? formatMoney(final) : '';
      const metaText = tile && hasFlavorUI && bagCount > 0 ? '(' + bagCount + ' bag' + (bagCount === 1 ? '' : 's') + ')' : '';
      totalEls.forEach((el) => { el.textContent = totalText; });
      totalMetaEls.forEach((el) => { el.textContent = metaText; });
      const compareEls = root.querySelectorAll('[data-total-compare]');
      const showCompare = tile && isSub && subscribeDiscountPct > 0;
      compareEls.forEach((el) => {
        if (showCompare) {
          el.textContent = formatMoney(base);
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
      if (tile) {
        if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(base);
        if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(Math.round(base * subscribeFactor));
        if (subscribeCompareEl) subscribeCompareEl.textContent = formatMoney(base);
      }
      updateSubmitState();
    }

    // A stable signature for the bundle currently configured in the UI, for a
    // given purchase mode ('onetime' or 'subscribe'). The mode is part of the
    // key so a one-time bundle and a subscription of the same bundle are
    // tracked separately. Subscription frequency is intentionally NOT included,
    // so any frequency of a bundle counts as that subscription being in cart.
    // The same signature is attached to every cart line via _bundle_key so we
    // can tell when an identical bundle is already sitting in the cart.
    // Returns null until the selection is complete enough to identify a bundle.
    function bundleKeyForMode(mode) {
      if (!hasFlavorUI) {
        const v = getSelectedVariant();
        return v ? 'b:' + v.id + ':' + mode : null;
      }
      const flavors = getSelectedFlavors();
      if (!flavors.length || flavors.length < visibleBagRowCount()) return null;
      const ids = flavors
        .map((f) => { const v = findVariant(f); return v ? v.id : 'x'; })
        .sort()
        .join(',');
      return 'b:' + bagCount + ':' + ids + ':' + mode;
    }

    function currentBundleKey() {
      return bundleKeyForMode(isSubscribe() ? 'subscribe' : 'onetime');
    }

    function modeInCart(mode) {
      const key = bundleKeyForMode(mode);
      return !!(key && cartBundleKeys.has(key));
    }

    function validateSelection() {
      if (!hasFlavorUI) {
        if (!getSelectedTile() && tiles.length) return { ok: false, reason: 'no-tile' };
        const available = !variants.length || variants.some((v) => v.available);
        return available ? { ok: true } : { ok: false, reason: 'soldout' };
      }
      if (!getSelectedTile()) return { ok: false, reason: 'no-tile' };
      const visibleCount = visibleBagRowCount();
      if (visibleCount === 0) return { ok: false, reason: 'no-tile' };
      const flavors = getSelectedFlavors();
      if (flavors.length < visibleCount) return { ok: false, reason: 'select' };
      for (const f of flavors) {
        const v = findVariant(f);
        if (!v) return { ok: false, reason: 'unavailable' };
        if (!v.available) return { ok: false, reason: 'soldout' };
      }
      return { ok: true };
    }

    function updateSubmitState() {
      const liveBtns = root.querySelectorAll('.bundle-pdp__submit');
      if (!liveBtns.length) return;
      if (cartLimitReached) {
        liveBtns.forEach((btn) => {
          btn.disabled = true;
          btn.classList.add('is-sold-out');
          btn.classList.remove('is-build-mode');
        });
        submitLabelEls.forEach((el) => { el.textContent = 'Already in cart'; });
        return;
      }
      // Flag each purchase option independently: a one-time bundle and a
      // subscription of the same bundle are tracked separately.
      const onetimeInCart = modeInCart('onetime');
      const subscribeInCart = modeInCart('subscribe');
      if (onetimeOptionLabel) onetimeOptionLabel.classList.toggle('is-in-cart', onetimeInCart);
      if (subscribeOptionLabel) subscribeOptionLabel.classList.toggle('is-in-cart', subscribeInCart);
      const selectedModeInCart = isSubscribe() ? subscribeInCart : onetimeInCart;
      if (selectedModeInCart) {
        liveBtns.forEach((btn) => {
          btn.disabled = true;
          btn.classList.add('is-sold-out');
          btn.classList.remove('is-build-mode');
        });
        submitLabelEls.forEach((el) => { el.textContent = 'Bundle is already in cart'; });
        return;
      }
      const result = validateSelection();
      const buildMode = !result.ok && (result.reason === 'no-tile' || result.reason === 'select');
      let labelText;
      if (!result.ok) {
        labelText = buildMode ? buildLabel : 'Sold out';
      } else {
        labelText = isSubscribe() ? subscribeLabel : onetimeLabel;
      }
      liveBtns.forEach((btn) => {
        // In build mode we keep the button enabled so clicking it scrolls
        // the user back to the pack selector (handled in the click listener).
        btn.disabled = !result.ok && !buildMode;
        btn.classList.toggle('is-sold-out', !result.ok && !buildMode);
        btn.classList.toggle('is-build-mode', buildMode);
      });
      submitLabelEls.forEach((el) => { el.textContent = labelText; });
    }

    function updateOptionSelectionUI() {
      if (subscribeOptionLabel) subscribeOptionLabel.classList.toggle('is-selected', isSubscribe());
      if (onetimeOptionLabel) onetimeOptionLabel.classList.toggle('is-selected', !isSubscribe());
      if (sellingPlanInput) {
        if (isSubscribe() && frequencySelect) {
          sellingPlanInput.value = frequencySelect.value;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
    }

    function updateGalleryForTile(tile) {
      if (root.dataset.lockGallery === 'true') return;
      const mediaId = tile && tile.dataset.mediaId;
      if (!mediaId) return;
      const sectionId = root.dataset.section;
      const fullMediaId = sectionId ? sectionId + '-' + mediaId : mediaId;
      root.querySelectorAll('media-gallery').forEach((gallery) => {
        const viewer = gallery.querySelector('[id^="GalleryViewer"]');
        if (!viewer || !viewer.querySelector('[data-media-id="' + fullMediaId + '"]')) return;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(fullMediaId, false);
        }
      });
    }

    tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        tiles.forEach((t) => {
          t.classList.remove('is-selected');
          t.setAttribute('aria-checked', 'false');
        });
        tile.classList.add('is-selected');
        tile.setAttribute('aria-checked', 'true');
        bagCount = parseInt(tile.dataset.bagCount, 10) || 1;
        updateBagVisibility();
        updateTotals();
        updateGalleryForTile(tile);
      });
    });

    // if (flavorContainer) {
    //   flavorContainer.addEventListener('change', (event) => {
    //     const sel = event.target.closest('.bundle-pdp__flavor-select');
    //     if (!sel) return;
    //     updateTotals();
    //   });
    // }
     if (flavorContainer) {
      flavorContainer.addEventListener('change', (event) => {
        const sel = event.target.closest('.bundle-pdp__flavor-select');
        if (!sel) return;
        const errorWrapper = root.querySelector('.product-form__error-message-wrapper');
        if (errorWrapper) errorWrapper.setAttribute('hidden', '');
        updateTotals();
      });
    }
    function setPurchaseMode(mode) {
      if (subscribeRadio) subscribeRadio.checked = mode === 'subscribe';
      if (onetimeRadio) onetimeRadio.checked = mode === 'onetime';
      console.log('[bundle-pdp] mode →', mode, {
        subscribeChecked: subscribeRadio && subscribeRadio.checked,
        onetimeChecked: onetimeRadio && onetimeRadio.checked,
      });
      updateOptionSelectionUI();
      updateTotals();
    }

    if (subscribeOptionLabel) {
      subscribeOptionLabel.addEventListener('click', (event) => {
        if (event.target.closest('[data-selling-plan-select]')) return;
        setPurchaseMode('subscribe');
      });
    }
    if (onetimeOptionLabel) {
      onetimeOptionLabel.addEventListener('click', () => {
        setPurchaseMode('onetime');
      });
    }

    if (form) {
      form.addEventListener('change', (event) => {
        const t = event.target;
        if (!t) return;
        if (t.matches('[data-selling-plan-select]')) {
          updateOptionSelectionUI();
          updateTotals();
        }
      });
    }

    function collectItems() {
      const items = [];
      const bundleKey = currentBundleKey();
      if (!hasFlavorUI) {
        const variantInput = form && form.querySelector('[name="id"]');
        const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!variantId) return items;
        const sellingPlanId = isSubscribe() && sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : null;
        const item = { id: variantId, quantity: 1 };
        const props = {};
        if (cartLimit > 0) props._cart_limit = String(cartLimit);
        if (bundleKey) props._bundle_key = bundleKey;
        if (Object.keys(props).length) item.properties = props;
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        items.push(item);
        return items;
      }

      const flavors = getSelectedFlavors();
      if (flavors.length === 0) return items;

      const sellingPlanId = isSubscribe() && sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : null;

      // One line item per bag so Shopify's automatic product discount can
      // apply per-quantity tiers; _bag_position preserves the user's bag order.
      flavors.forEach((flavor, i) => {
        const v = findVariant(flavor);
        if (!v) return;
        const item = {
          id: v.id,
          quantity: 1,
          properties: { _bag_position: String(i + 1) },
        };
        if (bundleKey) item.properties._bundle_key = bundleKey;
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        items.push(item);
      });
      return items;
    }

    // async function addToCart() {
    //   const items = collectItems();
    //   console.log('[bundle-pdp] submit', { items, bagCount, isSubscribe: isSubscribe(), sellingPlan: sellingPlanInput && sellingPlanInput.value });
    //   if (items.length === 0) {
    //     console.warn('[bundle-pdp] no items collected — check flavor pills + tile + variant lookup.');
    //     return;
    //   }  

    //   const errorWrapper = root.querySelector('.product-form__error-message-wrapper');
    //   const errorMessage = root.querySelector('.product-form__error-message');
    //   const hideError = () => { if (errorWrapper) errorWrapper.setAttribute('hidden', ''); };
    //   const showError = (msg) => {
    //     if (errorWrapper && errorMessage) {
    //       errorMessage.textContent = msg;
    //       errorWrapper.removeAttribute('hidden');
    //     }
    //   };
    //   hideError();

    //   const validity = validateSelection();
    //   if (!validity.ok) {
    //     showError(
    //       validity.reason === 'no-tile'
    //         ? 'Please choose your quantity to build your bundle.'
    //         : validity.reason === 'select'
    //           ? 'Please select your flavors.'
    //           : 'Sorry, the selected combination is sold out.'
    //     );
    //     updateSubmitState();
    //     return;
    //   }

    async function addToCart() {
        const errorWrapper = root.querySelector('.product-form__error-message-wrapper');
        const errorMessage = root.querySelector('.product-form__error-message');
        const hideError = () => { if (errorWrapper) errorWrapper.setAttribute('hidden', ''); };
        const showError = (msg) => {
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = msg;
            errorWrapper.removeAttribute('hidden');
          }
        };
        hideError();

        const validity = validateSelection();
        if (!validity.ok) {
          showError(
            validity.reason === 'no-tile'
              ? 'Please choose your quantity to build your bundle.'
              : validity.reason === 'select'
                ? 'Please select your flavors.'
                : 'Sorry, the selected combination is sold out.'
          );
          updateSubmitState();
          return;
        }

        const items = collectItems();
        console.log('[bundle-pdp] submit', { items, bagCount, isSubscribe: isSubscribe(), sellingPlan: sellingPlanInput && sellingPlanInput.value });
        if (items.length === 0) {
          console.warn('[bundle-pdp] no items collected — check flavor pills + tile + variant lookup.');
          return;
        }

      const liveBtns = root.querySelectorAll('.bundle-pdp__submit');
      liveBtns.forEach((btn) => {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      });

      try {
        const cartAction = root.dataset.cartAction || 'checkout';
        const cartDrawer = cartAction === 'drawer' ? document.querySelector('cart-drawer') : null;
        const url = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js';

        const payload = { items };
        if (cartDrawer) {
          payload.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
          payload.sections_url = window.location.pathname;
        }

        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(payload),
        });
        const responseBody = await res.json().catch(() => ({}));
        console.log('[bundle-pdp] /cart/add.js response', res.status, responseBody);
        if (!res.ok) {
          throw new Error(responseBody.description || responseBody.message || 'Could not add to cart');
        }

        if (cartAction === 'drawer' && cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(responseBody);
          enforceDrawerCartLimit(cartDrawer, productId, cartLimit);
          checkCartLimit();
        } else if (cartAction === 'drawer' && !cartDrawer) {
          // Cart drawer not in DOM — theme cart type must be set to Drawer in Theme Settings
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } else if (cartAction === 'cart') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } else {
          window.location.href = '/checkout';
        }

      } catch (err) {
        showError(err.message || 'Could not add to cart');
      } finally {
        liveBtns.forEach((btn) => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
        });
      }
    }

    function scrollToBundleBuilder() {
      const target = root.querySelector('.bundle-pdp__quantity-section') || tilesContainer || root;
      if (!target) return;
      const header = document.querySelector('.section-header, sticky-header, .header-wrapper');
      const headerOffset = header ? header.getBoundingClientRect().height : 0;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    if (form) {
      // form.addEventListener('submit', (event) => {
      //   event.preventDefault();
      //   const realBtn = form.querySelector('button[name="add"]');
      //   if (realBtn && realBtn.classList.contains('is-build-mode')) {
      //     scrollToBundleBuilder();
      //     return;
      //   }
      //   addToCart();
      // });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const realBtn = form.querySelector('button[name="add"]');
        if (realBtn && realBtn.classList.contains('is-build-mode')) {
          const result = validateSelection();
          if (result.reason === 'no-tile') {
            scrollToBundleBuilder();
            return;
          }
          addToCart();
          return;
        }
        addToCart();
      });
    }

    root.addEventListener('click', (event) => {
      const btn = event.target.closest('.bundle-pdp__submit');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();

      // if (btn.classList.contains('is-build-mode')) {
      //   scrollToBundleBuilder();
      //   return;
      // }
      if (btn.classList.contains('is-build-mode')) {
        const result = validateSelection();
        if (result.reason === 'no-tile') {
          scrollToBundleBuilder();
          return;
        }
        addToCart();
        return;
      }

      // Sticky button is outside the form and has no name="add", so third-party apps
      // like Honeycomb that attach listeners to the real submit button never see the click.
      // Proxy through the real button so those listeners fire, then that click re-enters
      // this handler (isSticky will be false) and calls addToCart().
      if (btn.hasAttribute('data-bundle-sticky-submit')) {
        const realBtn = form && form.querySelector('button[name="add"]');
        if (realBtn && !realBtn.disabled) realBtn.click();
        return;
      }

      addToCart();
    });

    updateBagVisibility();
    updateOptionSelectionUI();
    updateTotals();
    checkCartLimit();
    watchDrawerForLimit(document.querySelector('cart-drawer'), productId, cartLimit);

    if (stickyCta) {
      stickyCta.setAttribute('aria-hidden', 'false');

      // Hide the sticky CTA whenever the inline submit button is visible —
      // they're redundant when both are on screen.
      const inlineSubmit = form && form.querySelector('button[name="add"]');
      if (inlineSubmit && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            stickyCta.classList.toggle('is-hidden', entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -80px 0px', threshold: 0.01 });
        io.observe(inlineSubmit);
      }
    }

    window.addEventListener('pageshow', () => {
      console.log('[bundle-pdp] pageshow sync', {
        subscribeChecked: subscribeRadio && subscribeRadio.checked,
        onetimeChecked: onetimeRadio && onetimeRadio.checked,
      });
      updateOptionSelectionUI();
      updateTotals();
      // Re-read the live cart on every show — including back/forward cache
      // restores, where the page keeps frozen JS state and would otherwise
      // miss bundles added just before the customer navigated away.
      checkCartLimit();
    });
  }

  function initAll() {
    document.querySelectorAll('.bundle-pdp').forEach(initBundlePdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sec = event.target.querySelector('.bundle-pdp');
    if (sec) initBundlePdp(sec);
  });
})();